export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  tags: string[];
  author: string;
  publishDate: string;
  viewCount: number;
  commentCount: number;
  isHot: boolean;
  isNew: boolean;
}

export const categories = [
  { name: '网红塌房', slug: 'influencer-scandal', icon: 'ri-user-unfollow-line', description: '网红人设崩塌现场直击，揭秘镜头背后的真实面目' },
  { name: '明星爆料', slug: 'celebrity-expose', icon: 'ri-sparkling-line', description: '娱乐圈一手猛料，明星大瓜第一时间送达' },
  { name: '私密聊天', slug: 'private-chats', icon: 'ri-message-3-line', description: '私密聊天记录泄露，还原最真实的对话现场' },
  { name: '反差视频', slug: 'contrast-videos', icon: 'ri-contrast-2-line', description: '博主反差猛料合集，台前幕后两副面孔全纪录' },
  { name: '每日大赛', slug: 'daily-competition', icon: 'ri-fire-line', description: '每日吃瓜大赛，最新最热黑料实时追踪' },
];

export const hotTags = [
  '塌房', '出轨', '聊天记录', '实锤', '直播翻车', '人设崩塌', '私密视频', '录音曝光',
  '道歉声明', '退网', '小三', '劈腿', '阴阳合同', '偷税', '假唱', '剧本',
];

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '某千万粉丝颜值博主被曝私下言论极端，聊天记录曝光后粉丝集体脱粉',
    excerpt: '拥有超过1200万粉丝的知名颜值博主近日陷入舆论风暴，多段私密聊天记录被曝光，内容涉及对粉丝的轻蔑言论及对同行的人身攻击，引发全网热议。',
    content: `<h2>事件起因</h2><p>近日，一位自称是该博主前工作人员的匿名人士向本网提供了大量聊天记录截图。据该人士透露，这位以"温柔治愈"人设走红的博主私下性格截然不同，经常在工作群中对工作人员进行言语暴力，对粉丝群体也多次发表不尊重言论。</p><h2>聊天记录曝光</h2><p>曝光的聊天记录显示，该博主曾在多个场合嘲讽粉丝"都是韭菜"，表示自己做内容"随便拍拍就有钱赚"。更令人震惊的是，她还在群聊中对多位同平台博主进行恶意诋毁，编造不实信息试图破坏同行声誉。</p><blockquote>粉丝就是我的提款机，随便发个视频他们就会给我打赏。这帮人傻得很，根本不用认真对待。</blockquote><p>这段被曝光的对话截图在社交媒体上迅速传播，#某博主人设崩塌#话题阅读量在12小时内突破3亿。大量粉丝在评论区表示"看了这些记录感觉被背叛了"。</p><h2>品牌方紧急解约</h2><p>截至目前，已有至少5个品牌方发布声明与该博主解除合作关系。据业内人士估算，此次事件将给该博主带来超过800万元的直接经济损失。</p><h2>当事人回应</h2><p>事件发酵48小时后，该博主发布了一段道歉视频，称聊天记录"被断章取义"，但并未获得网友认可。评论区高赞留言写道："聊天记录不会说谎，你的人设彻底塌了。"</p>`,
    category: '网红塌房',
    categorySlug: 'influencer-scandal',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20scene%20of%20a%20smartphone%20displaying%20leaked%20chat%20messages%20in%20Chinese%20text%2C%20dark%20moody%20atmosphere%20with%20red%20accent%20lighting%2C%20the%20phone%20screen%20glowing%20ominously%20against%20a%20dark%20background%2C%20cinematic%20photography%20style%20with%20shallow%20depth%20of%20field%2C%20warm%20and%20dark%20contrast%20tones%20creating%20a%20sense%20of%20scandal%20and%20exposure%2C%20editorial%20photojournalism%20aesthetic&width=800&height=500&seq=article-1-cover&orientation=landscape',
    tags: ['塌房', '人设崩塌', '聊天记录', '颜值博主'],
    author: '吃瓜前线',
    publishDate: '2026-07-06',
    viewCount: 1285000,
    commentCount: 36200,
    isHot: true,
    isNew: true,
  },
  {
    id: 'article-2',
    title: '顶流男星深夜密会神秘女子视频流出，工作室凌晨紧急发声明',
    excerpt: '某顶流男演员被拍到深夜与一名神秘女子在私人会所密会长达4小时，监控视频被匿名人士提供给多家媒体，工作室凌晨3点紧急发布律师声明。',
    content: `<h2>视频曝光经过</h2><p>7月5日晚间，一段时长约30秒的监控视频开始在各大社交平台流传。视频显示，某顶流男演员于凌晨1点左右进入一家高端私人会所，随后一名身着黑色连衣裙的女子也进入同一会所。两人直至凌晨5点才先后离开。</p><h2>工作室紧急回应</h2><p>视频发酵数小时后，该男星工作室于凌晨3点发布紧急声明，称视频中男子"确实为本人"，但强调"只是与多年好友的正常社交活动"，并警告传播者将追究法律责任。</p><blockquote>我们对恶意偷拍和散布不实信息的行为表示强烈谴责，已委托律师团队固定证据并启动法律程序。</blockquote><h2>网友反应两极</h2><p>声明发布后，网友反应呈现两极分化。一部分粉丝表示支持偶像维权，认为偷拍行为侵犯隐私；另一部分网友则质疑"凌晨密会4小时"的解释不合常理。</p><h2>业内人士分析</h2><p>多位娱乐圈资深人士匿名表示，此类事件的公关处理方式通常预示着背后有更复杂的故事。一位不愿透露姓名的经纪人称："凌晨3点发声明本身就不寻常，说明团队非常紧张。"</p>`,
    category: '明星爆料',
    categorySlug: 'celebrity-expose',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20grainy%20nighttime%20surveillance%20style%20photograph%20of%20a%20luxury%20private%20club%20entrance%20with%20silhouetted%20figures%2C%20moody%20amber%20street%20lighting%2C%20dark%20atmosphere%20with%20a%20sense%20of%20secrecy%20and%20scandal%2C%20cinematic%20noir%20aesthetic%20with%20deep%20shadows%20and%20warm%20highlights%2C%20editorial%20photography%20style%20with%20film%20grain%20texture&width=800&height=500&seq=article-2-cover&orientation=landscape',
    tags: ['出轨', '实锤', '顶流明星', '密会'],
    author: '八卦探长',
    publishDate: '2026-07-05',
    viewCount: 2150000,
    commentCount: 58200,
    isHot: true,
    isNew: true,
  },
  {
    id: 'article-3',
    title: '知名美妆博主直播翻车，产品成分被专业化学师当场揭穿',
    excerpt: '拥有800万粉丝的美妆博主在直播带货时，被一名自称化学博士的观众当场指出产品成分表存在严重造假，直播间瞬间炸锅。',
    content: `<h2>直播翻车全过程</h2><p>7月4日晚，知名美妆博主"小仙女CC"在直播间推广一款售价299元的"贵妇面霜"时，突然被一条弹幕打断。一位ID为"化学博士小王"的观众在弹幕中指出，该产品宣传的"含有玻尿酸"实际成分表中的透明质酸钠含量极低，几乎可以忽略不计。</p><h2>专业打假引热议</h2><p>该观众随后在弹幕中逐条分析了产品的成分表，指出多个宣传与实际不符的地方。由于分析过于专业，直播间观众纷纷要求博主回应。博主最初试图忽略这些弹幕，但在刷屏压力下不得不正面回应。</p><blockquote>我看到弹幕里有人说成分的问题，我想说的是...我们这个是品牌方提供的资料，具体的我也不太清楚...</blockquote><p>这段支支吾吾的回应被网友录屏传播，24小时内播放量突破5000万。话题#小仙女CC直播翻车#迅速登上热搜榜首。</p><h2>品牌方连夜下架</h2><p>事件发生后，相关产品已在各大电商平台被紧急下架。市场监督管理部门表示已关注到此事，将依法展开调查。</p>`,
    category: '网红塌房',
    categorySlug: 'influencer-scandal',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20live%20streaming%20studio%20setup%20with%20a%20beauty%20influencer%20looking%20shocked%20and%20nervous%2C%20bright%20ring%20light%20illuminating%20cosmetic%20products%20on%20a%20desk%2C%20warm%20makeup%20studio%20lighting%20with%20scattered%20beauty%20products%2C%20tense%20atmosphere%20captured%20in%20editorial%20photography%20style%2C%20clean%20minimalist%20background%20with%20soft%20pink%20and%20warm%20neutral%20tones&width=800&height=500&seq=article-3-cover&orientation=landscape',
    tags: ['直播翻车', '美妆博主', '成分造假', '带货'],
    author: '打假先锋',
    publishDate: '2026-07-04',
    viewCount: 980000,
    commentCount: 24500,
    isHot: true,
    isNew: false,
  },
  {
    id: 'article-4',
    title: '已婚男网红出轨女粉丝，私密聊天记录完整曝光，细节令人咋舌',
    excerpt: '一位以"好丈夫好爸爸"人设走红的男网红，被曝出轨多名女粉丝。超过200页的私密聊天记录被泄露，内容露骨程度超出想象。',
    content: `<h2>事件曝光</h2><p>一位自称掌握了大量证据的匿名爆料人，向本网提供了超过200页的聊天记录截图。截图显示，这位以"宠妻狂魔"形象活跃在短视频平台的男网红，在过去两年间至少与6名女粉丝保持着不正当关系。</p><h2>聊天记录细节</h2><p>曝光的聊天记录时间跨度从2024年初至2026年6月，对话内容极其露骨。更令人震惊的是，该网红在聊天中多次贬低自己的妻子，称婚姻"只是一场表演"，并表示"粉丝才是真爱"。</p><blockquote>我跟我老婆早就没感情了，都是为了孩子和流量在演戏。跟你在一起我才觉得是真的活着。</blockquote><p>这段对话在网络上引发强烈反响，许多网友表示"这种人设崩塌得太彻底了"。该网红的妻子目前尚未公开回应，但其社交账号已经清空了所有与丈夫相关的内容。</p><h2>商业损失评估</h2><p>据不完全统计，事件发生72小时内，该网红已失去12个商业合作，预估损失超过1500万元。其个人账号在一周内掉粉超过200万。</p>`,
    category: '私密聊天',
    categorySlug: 'private-chats',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20smartphone%20lying%20on%20a%20dark%20wooden%20surface%20displaying%20glowing%20chat%20bubbles%20with%20Chinese%20text%2C%20dramatic%20side%20lighting%20creating%20long%20shadows%2C%20a%20wedding%20ring%20placed%20ominously%20next%20to%20the%20phone%2C%20dark%20moody%20atmosphere%20in%20warm%20amber%20and%20deep%20red%20tones%2C%20cinematic%20still%20life%20photography%20with%20shallow%20depth%20of%20field&width=800&height=500&seq=article-4-cover&orientation=landscape',
    tags: ['出轨', '聊天记录', '已婚网红', '女粉丝'],
    author: '吃瓜前线',
    publishDate: '2026-07-03',
    viewCount: 1670000,
    commentCount: 45200,
    isHot: true,
    isNew: false,
  },
  {
    id: 'article-5',
    title: '当红说唱歌手被爆料假唱，现场音频对比实锤证据全面公开',
    excerpt: '某当红说唱歌手在音乐节演出中被疑假唱，专业音频工程师将现场录音与录音室版本进行波形对比，结果令人震惊。',
    content: `<h2>假唱质疑起源</h2><p>7月2日，在某大型音乐节演出后，多位现场观众在社交平台发帖质疑该说唱歌手存在假唱行为。观众反映，歌手在高速rap段落中嘴型与音频不同步，且演出全程气息过于平稳，"完全不像是现场表演"。</p><h2>音频对比实锤</h2><p>一位自称拥有12年音频工程经验的网友将现场粉丝拍摄的视频音频与歌手的录音室版本进行了专业波形对比分析。分析结果显示，两段音频在多个关键段落的波形完全重合，这在真实的现场表演中几乎不可能发生。</p><blockquote>从专业角度来说，现场演唱因为呼吸、走位、情绪等因素，波形不可能与录音室版本100%吻合。这次对比的吻合度超过99%，基本可以确认是播放预录音频。</blockquote><h2>说唱圈反应</h2><p>事件在说唱圈引发巨大震动。多位知名rapper公开发声，表示假唱在说唱圈是不可原谅的行为。一位资深制作人表示："说唱的核心就是现场的表达力，假唱等于背叛了这个文化。"</p>`,
    category: '反差视频',
    categorySlug: 'contrast-videos',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20concert%20stage%20scene%20with%20a%20rapper%20silhouetted%20against%20bright%20stage%20lights%2C%20audio%20waveform%20visualization%20overlaid%20as%20a%20transparent%20effect%2C%20vibrant%20red%20and%20amber%20concert%20lighting%20creating%20dramatic%20atmosphere%2C%20energetic%20music%20festival%20vibe%20captured%20in%20editorial%20photography%20style%2C%20crowd%20silhouettes%20in%20the%20foreground&width=800&height=500&seq=article-5-cover&orientation=landscape',
    tags: ['假唱', '说唱', '实锤', '音乐节'],
    author: '八卦探长',
    publishDate: '2026-07-02',
    viewCount: 756000,
    commentCount: 18900,
    isHot: false,
    isNew: false,
  },
  {
    id: 'article-6',
    title: '电竞女主播深夜私密照泄露，本人回应系AI换脸遭网友群嘲',
    excerpt: '一位知名电竞女主播的私密照片在深夜被大量传播，当事人火速回应称系AI换脸伪造，但技术专家和网友均不买账。',
    content: `<h2>照片泄露</h2><p>7月1日凌晨，一组疑似某知名电竞女主播的私密照片在多个社交群组中疯传。照片中的人物与该主播高度相似，背景被网友扒出正是该主播家中的装修风格。</p><h2>AI换脸说辞遭质疑</h2><p>事件发酵后，该主播在当日下午发布声明，称照片系"恶意AI换脸伪造"，并表示已报警处理。然而，多位AI技术专家在分析了照片后提出了不同看法。</p><blockquote>我们从照片的EXIF数据、光影分布、皮肤纹理等多个维度进行了分析，这张照片是AI生成的概率极低。照片中的光影与环境的匹配度达到真实拍摄水平，目前公开的AI技术很难做到这种程度。</blockquote><h2>直播平台介入</h2><p>该主播所在的直播平台发布公告，表示将配合警方调查，并在此期间暂停该主播的直播活动。这一举措被不少网友解读为平台已经掌握了更多内部信息。</p>`,
    category: '私密聊天',
    categorySlug: 'private-chats',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20gaming%20streaming%20setup%20with%20professional%20equipment%20in%20a%20dimly%20lit%20room%2C%20RGB%20lighting%20creating%20a%20dramatic%20cyberpunk%20atmosphere%2C%20multiple%20monitors%20displaying%20gaming%20interfaces%2C%20the%20scene%20has%20a%20sense%20of%20digital%20mystery%20and%20scandal%2C%20editorial%20photography%20with%20warm%20neon%20accents%20and%20deep%20shadows&width=800&height=500&seq=article-6-cover&orientation=landscape',
    tags: ['私密照', '电竞主播', 'AI换脸', '泄露'],
    author: '吃瓜前线',
    publishDate: '2026-07-01',
    viewCount: 1130000,
    commentCount: 31200,
    isHot: false,
    isNew: false,
  },
  {
    id: 'article-7',
    title: '知名情感博主被曝PUA多名学员，收费课程暗藏精神操控套路',
    excerpt: '一位号称"情感导师"的知名博主被多名学员联合举报，指控其在收费课程中系统性实施PUA精神操控，受害者遍布全国。',
    content: `<h2>受害者联合举报</h2><p>6月30日，来自全国各地的20余名女性通过社交媒体联合发布了一封公开信，举报一位拥有500万粉丝的"情感导师"在收费课程中实施精神操控。举报信详细描述了该博主如何利用学员的情感脆弱期进行心理操纵。</p><h2>课程内幕曝光</h2><p>据受害者描述，该博主的"情感成长课程"收费从9999元到49999元不等。课程内容从最初的情感咨询逐渐演变为对学员进行人格贬低、孤立其社交圈、要求学员完全服从导师安排等PUA典型手段。</p><blockquote>他说只有他才能真正理解我，让我不要跟家人朋友联系太多。每次我提出质疑，他就会说我不够"觉醒"。现在回想起来，那完全就是精神控制。</blockquote><p>一位受访的受害者表示，自己在该课程中花费了超过20万元，不仅情感问题没有解决，反而患上了严重的抑郁症。</p><h2>平台封号与法律追责</h2><p>事件曝光后，该博主在多个平台的账号已被封禁。律师表示，其行为可能涉嫌诈骗罪和精神损害，受害者可通过法律途径维权。</p>`,
    category: '每日大赛',
    categorySlug: 'daily-competition',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20minimalist%20office%20setting%20with%20a%20laptop%20displaying%20a%20online%20course%20interface%20in%20Chinese%2C%20scattered%20course%20materials%20and%20notes%20on%20a%20desk%2C%20warm%20indoor%20lighting%20with%20a%20sense%20of%20deception%20and%20manipulation%2C%20subtle%20red%20accent%20elements%2C%20editorial%20photography%20style%20with%20clean%20composition%20and%20soft%20shadows&width=800&height=500&seq=article-7-cover&orientation=landscape',
    tags: ['PUA', '情感博主', '精神操控', '维权'],
    author: '打假先锋',
    publishDate: '2026-06-30',
    viewCount: 893000,
    commentCount: 27800,
    isHot: false,
    isNew: false,
  },
  {
    id: 'article-8',
    title: '健身网红私下饮食大揭秘：镜头前吃减脂餐，镜头后狂炫火锅烧烤',
    excerpt: '一位以"自律生活"著称的健身网红被餐厅服务员曝光，其在拍摄完减脂餐视频后，转头就去了隔壁火锅店大快朵颐。',
    content: `<h2>服务员实名爆料</h2><p>6月28日，一位自称在某知名火锅连锁店工作的服务员在社交媒体上发帖，称某健身网红是店里的常客，每次来都点大量高热量食物。"她发完健身视频就来我们店，牛油锅底、毛肚、肥牛、虾滑，一个人能吃三四百。"</p><h2>反差细节曝光</h2><p>该服务员还提供了多张该网红的消费小票照片，时间与她发布"健康减脂餐"视频的日期高度吻合。更令人捧腹的是，有一次该网红拍完"晨跑打卡"视频后不到一小时，就出现在了火锅店。</p><blockquote>她说自己每天早上五点起来跑步，但有一次我上早班，她九点多就来吃火锅了。那天她刚发了晨跑视频，配文还是"自律的人生不需要解释"。</blockquote><h2>网友反应</h2><p>该帖子引发了网友的狂欢式讨论，话题#自律人设翻车#一度登上热搜。不过也有不少网友表示理解："健身博主也是人，偶尔吃顿好的很正常，但别骗粉丝就行。"</p>`,
    category: '反差视频',
    categorySlug: 'contrast-videos',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20split%20composition%20scene%2C%20left%20side%20showing%20a%20fitness%20influencer%20with%20healthy%20salad%20bowl%20in%20bright%20clean%20lighting%2C%20right%20side%20showing%20the%20same%20scene%20transforming%20into%20a%20hotpot%20restaurant%20with%20steaming%20spicy%20broth%20and%20meat%20platters%2C%20dramatic%20contrast%20between%20the%20two%20worlds%2C%20editorial%20photography%20style%20with%20clean%20composition&width=800&height=500&seq=article-8-cover&orientation=landscape',
    tags: ['反差', '健身网红', '人设崩塌', '饮食'],
    author: '八卦探长',
    publishDate: '2026-06-28',
    viewCount: 1340000,
    commentCount: 38900,
    isHot: false,
    isNew: false,
  },
  {
    id: 'article-9',
    title: '配音圈顶流被扒学历造假，自称名校毕业实为培训机构短期班',
    excerpt: '一位在配音圈拥有极高人气的声优被网友扒出学历造假，其自称的某985高校播音系学历实际上只是一家培训机构的3个月速成班。',
    content: `<h2>学历造假被揭穿</h2><p>6月25日，一位自称是该声优"老同学"的网友在社交平台发帖，称该声优的985高校学历纯属虚构。据其透露，该声优仅在2000元报名费的一家配音培训机构完成了3个月的短期培训课程。</p><h2>当事人回应</h2><p>事件曝光后，该声优在直播间哭诉回应，称自己"从未明确说过是985毕业"，是粉丝自己过度解读。然而网友迅速扒出了她多次在公开场合自称"X大播音系"的视频片段。</p><blockquote>我确实在XX大学旁边上过课，那也算是在XX大学学习过吧...我没有恶意欺骗大家的意思...</blockquote><p>这番解释被网友戏称为"重新定义了大学"。</p><h2>行业反思</h2><p>此事件引发了配音行业对从业者背景真实性的广泛讨论。多位业内人士呼吁建立行业透明化机制，要求配音演员如实公开教育背景和工作经历。</p>`,
    category: '明星爆料',
    categorySlug: 'celebrity-expose',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20professional%20recording%20studio%20with%20a%20microphone%20and%20soundproofing%20panels%2C%20a%20diploma%20certificate%20placed%20on%20the%20mixing%20console%20with%20question%20marks%20as%20subtle%20visual%20elements%2C%20dramatic%20lighting%20with%20warm%20amber%20and%20deep%20shadows%2C%20editorial%20photography%20style%20creating%20a%20sense%20of%20exposure%20and%20scandal&width=800&height=500&seq=article-9-cover&orientation=landscape',
    tags: ['学历造假', '配音圈', '声优', '人设'],
    author: '打假先锋',
    publishDate: '2026-06-25',
    viewCount: 678000,
    commentCount: 15200,
    isHot: false,
    isNew: false,
  },
];

export const aboutInfo = {
  brandName: '51大赛吃瓜黑料网',
  founded: '2024',
  intro: '51大赛吃瓜黑料网创立于2024年，是国内领先的娱乐八卦资讯聚合平台。我们致力于为吃瓜爱好者提供最新、最全、最真实的第一手爆料资讯。从网红塌房到明星大瓜，从私密聊天记录泄露到反差视频曝光，51大赛始终站在吃瓜第一线，为千万用户提供不间断的吃瓜体验。',
  mission: '让每一个吃瓜群众都能第一时间吃到最新鲜、最真实的大瓜',
  values: ['真实客观', '快速及时', '深度挖掘', '用户至上'],
  stats: [
    { label: '累计爆料', value: '12,800+' },
    { label: '日活用户', value: '500万+' },
    { label: '独家首发', value: '3,200+' },
    { label: '合作媒体', value: '200+' },
  ],
  contact: {
    email: 'hello@ahljjx.cn',
    wechat: '51dasai_offical',
    address: '北京市朝阳区望京SOHO T2 15层',
  },
};

export const testimonials = [
  {
    id: 't1',
    name: '资深吃瓜人',
    role: '5年忠实用户',
    content: '跟了51大赛三年多了，确实是吃瓜界的信息枢纽。每次有大瓜都是这里最先看到，虽然有时候瓜太大有点噎得慌，但这种信息量真的没话说。',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Chinese%20professional%20in%20casual%20attire%2C%20confident%20expression%2C%20clean%20white%20background%2C%20editorial%20portrait%20photography%20with%20soft%20natural%20lighting%2C%20minimalist%20studio%20aesthetic&width=200&height=200&seq=testimonial-1&orientation=squarish',
  },
  {
    id: 't2',
    name: '娱乐圈观察者',
    role: '自媒体人',
    content: '做娱乐自媒体三年，51大赛是我每天必刷的素材来源。很多独家爆料在其他平台根本找不到，而且更新速度确实快，经常是我还没刷完一条，新的又来了。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20Chinese%20woman%20in%20modern%20office%20wear%2C%20friendly%20smile%2C%20clean%20white%20background%2C%20editorial%20portrait%20photography%20with%20natural%20lighting%2C%20minimalist%20aesthetic&width=200&height=200&seq=testimonial-2&orientation=squarish',
  },
];